import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AUTH } from '../contants/AUTH';

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		//adds authorization header with jwt token if available
		let token = localStorage.getItem(AUTH.token);
		if (token) {
			request = request.clone({
				setHeaders: {
					authorization: `Bearer ${token}`,
					'content-type': `application/json`
				}
			});
		}

		return next.handle(request);
	}

}



// WEBPACK FOOTER //
// ./src/app/services/jwt-interceptor.service.ts